var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.show, "max-width": "800px" },
      on: {
        input: function($event) {
          return _vm.$emit("cancel")
        }
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _vm._v(_vm._s(_vm.$t("invoicing.filters.scheduleTitle")))
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              value: _vm.filter
                                ? _vm.filter.transportEventFilterName
                                : "",
                              label: _vm.$t(
                                "invoicing.filters.transportEventFilterName"
                              ),
                              readonly: "",
                              dense: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              value: _vm.filter
                                ? _vm.filter.invoicingOptionsName
                                : "",
                              label: _vm.$t(
                                "invoicing.filters.invoicingOptionsName"
                              ),
                              readonly: "",
                              dense: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("invoicing.filters.scheduleName"),
                              clearable: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.name,
                              callback: function($$v) {
                                _vm.name = $$v
                              },
                              expression: "name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t(
                                "invoicing.filters.scheduleDescription"
                              ),
                              clearable: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.description,
                              callback: function($$v) {
                                _vm.description = $$v
                              },
                              expression: "description"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c("v-switch", {
                            attrs: {
                              label: _vm.$t(
                                "invoicing.filters.scheduleManualCron"
                              ),
                              dense: "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.manualCron,
                              callback: function($$v) {
                                _vm.manualCron = $$v
                              },
                              expression: "manualCron"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          !_vm.manualCron
                            ? _c("VueCronEditorBuefy", {
                                attrs: {
                                  visibleTabs: [
                                    "minutes",
                                    "hourly",
                                    "daily",
                                    "weekly",
                                    "monthly"
                                  ]
                                },
                                model: {
                                  value: _vm.cronExpression,
                                  callback: function($$v) {
                                    _vm.cronExpression = $$v
                                  },
                                  expression: "cronExpression"
                                }
                              })
                            : _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t(
                                    "invoicing.filters.scheduleCronExpression"
                                  ),
                                  dense: "",
                                  placeholder: "0 0 * * *"
                                },
                                model: {
                                  value: _vm.cronExpression,
                                  callback: function($$v) {
                                    _vm.cronExpression = $$v
                                  },
                                  expression: "cronExpression"
                                }
                              })
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("scheduler.utcNote", [_vm.utcDifference()])
                            )
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", loading: _vm.saving },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.save")))]
              ),
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("cancel")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.snackbarColor, timeout: "4000" },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function() {
                return [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          _vm.snackbar = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.close")))]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [_vm._v(" " + _vm._s(_vm.snackbarText) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }